var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      attrs: { title: "Justificativas", active: _vm.show },
      on: {
        "update:active": function($event) {
          return _vm.$emit("update:show")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "_suggestion-guest-justifications" },
        [
          _c("div", {
            directives: [
              {
                name: "html-safe",
                rawName: "v-html-safe",
                value: _vm.getIntroText(),
                expression: "getIntroText()"
              }
            ],
            staticClass: "pb-2"
          }),
          _vm._l(_vm.items, function(item, key) {
            return _c(
              "b-alert",
              { key: key, attrs: { show: "", variant: "warning" } },
              [
                item.suggestion_id
                  ? _c(
                      "div",
                      {
                        staticClass: "__item-alert h-full w-full flex flex-col"
                      },
                      [
                        _c("span", [
                          _vm._v("De "),
                          _c("i", [
                            _vm._v(
                              _vm._s(_vm.formatDate(item.suggestion_start_at))
                            )
                          ]),
                          _vm._v(" até "),
                          _c("i", [
                            _vm._v(
                              _vm._s(_vm.formatDate(item.suggestion_finish_at))
                            )
                          ])
                        ]),
                        _c("p", [_vm._v(_vm._s(item.text))])
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "__item-alert h-full w-full flex flex-col"
                      },
                      [
                        _c("span", [_vm._v("Não poderá participar do evento")]),
                        _c("p", [_vm._v(_vm._s(item.text))])
                      ]
                    )
              ]
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }